<template>
  <div class="form-group" :class="[classes]"
       v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh"
  >
    <label v-if="label!==null">
      {{ label }}
      <span style="color:red">{{ required ? '*' : '' }}</span>
    </label>
    <template v-if="selected_campaigns.length>1">
      <select class="form-control"
              :class="[computedValidationStatus]"
              id="campaigns"
              v-model="campaign"
              @change="set_campaign"
              :readonly="readOnly"
              :disabled="!enableComponent||readOnly">
        <template v-for="campaign in campaigns">
          <option :value="campaign.id" :key="'_cid'+_uid+campaign.id"> {{
              truncate(campaign.campaign_name, 50)
            }}
          </option>
        </template>
      </select>
    </template>
    <template v-else>
      <input v-show="campaign!==null"
             type="text"
             class="form-control-plaintext"
             :class="[computedValidationStatus]"
             :value="truncate(activeSingleCampaignData.campaign_name, 50)"
             autocomplete="new-password"
             readonly>
    </template>
    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" v-if="computedValidationStatus==='is-valid'">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid+'success_'+index">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" v-if="computedValidationStatus==='is-invalid'">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid+'error_'+index">{{ text }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import Vue from 'vue';
import Vuex from 'vuex'

export default {
  name: 'campaign-selector-single',
  mixins: [checkPermissions],
  props: {
    validation: {
      default: null
    },
    dataSource: {
      type: String,
      required: false
    },
    classes: {
      type: String,
      required: false
    },
    helpText: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    defaultValue: {
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    ...Vuex.mapGetters({selected_campaigns: 'rms_ui/auth/selected_campaigns'}),
    ...Vuex.mapGetters({selected_campaign: 'rms_ui/auth/single_campaign'}),
    input() {
      return this.$parent.data_provider_ref.record[this.dataSource];
    },
    computedValidationStatus() {
      return this.isValid === null ? "none" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
    },
    activeSingleCampaignData() {
      return this.auth.user.data_campaigns.filter(cp => cp.id == this.campaign)[0];
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }

  },
  watch: {
    selected_campaigns: {
      handler: function (campaigns) {
        if (campaigns.length == 0) {
          this.campaigns = this.auth.user.data_campaigns;
        } else if (campaigns.length == 1 && !this.readOnly) {
          this.campaigns = campaigns;
          this.campaign = campaigns[0].id;
          this.set_campaign();
        } else {
          this.campaigns = campaigns;
        }
      },
      deep: true
    },
    selected_campaign: function (val) {
      this.campaign = val;
    }
  },
  mounted() {
    if (this.dataSource) {
      if (this.$parent.data_provider_ref.record[this.dataSource] === undefined) {
        this.$parent.data_provider_ref.record[this.dataSource] = this.defaultValue ? this.defaultValue : this.selected_campaign;
      }
      setTimeout(() => {
        this.$set(this.$parent.data_provider_ref.inputs, this.dataSource, this);
      }, 1000);
    }
    this.campaign = this.defaultValue ? this.defaultValue : (this.selected_campaigns.length == 1 ? this.selected_campaigns[0].id : this.selected_campaign);
    this.set_campaign();
    if (this.selected_campaigns.length == 0) {
      this.campaigns = this.auth.user.data_campaigns;
    } else {
      this.campaigns = this.selected_campaigns;
    }
  },
  methods: {
    validate_input() {
      if (this.validation) {
        let res = this.validation(this.campaign, this.dataSource);
        this.isValid = res.isValid;
        this.validText = res.correct ? res.correct : null;
        this.invalidText = res.errors ? res.errors : null;
        return res.isValid;
      } else {
        return true;
      }
    },
    truncate(str, n) {
      if (str) {
        return (str.length > n) ? str.substr(0, n - 1) + "..." : str;
      }
      return str;
    },
    async set_campaign() {
      try {
        if (this.dataSource) {
          Vue.set(this.$parent.data_provider_ref.record, this.dataSource, this.campaign);
          this.validate_input();
        }
        this.$store.dispatch('rms_ui/auth/set_single_campaign', this.campaign);
        this.$emit('input', this.campaign);
        this.$emit('onChange', this.campaign);
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    }
  },
  data() {
    return {
      campaign: null,
      campaigns: [],
      isValid: null,
      validText: null,
      invalidText: null
    }
  }
}
</script>
